import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import MonthlyDemandTable from './MonthlyDemandTable'
import PersonLevelTable from './PersonLevelTable'
import { useProjectOverview } from '../../../hooks/queries/useProjectOverview'
import { PageContainer, PageTitle } from './ProjectOverview.styles'

const ProjectOverviewPage = ({ selectedProject, client }) => {
  const { data, isLoading, error } = useProjectOverview({
    projectId: selectedProject?._id ?? null,
    client,
  })

  if (!selectedProject) {
    return (
      <PageContainer>
        <Typography variant="body1" style={{ textAlign: 'center', color: '#666', marginTop: 80 }}>
          Select a project to view its overview.
        </Typography>
      </PageContainer>
    )
  }

  if (isLoading) {
    return (
      <PageContainer style={{ display: 'flex', justifyContent: 'center', marginTop: 80 }}>
        <CircularProgress />
      </PageContainer>
    )
  }

  if (error || !data) {
    return (
      <PageContainer>
        <Typography
          variant="body1"
          style={{ textAlign: 'center', color: '#d32f2f', marginTop: 80 }}
        >
          Failed to load project overview. Please try again.
        </Typography>
      </PageContainer>
    )
  }

  return (
    <PageContainer>
      <PageTitle>{data.projectName} Overview</PageTitle>
      <MonthlyDemandTable
        months={data.months}
        projectEndDate={data.projectEndDate}
        currency={data.currency}
      />
      <PersonLevelTable
        persons={data.personDetails.persons}
        month={data.personDetails.month}
        currency={data.currency}
      />
    </PageContainer>
  )
}

ProjectOverviewPage.propTypes = {
  selectedProject: PropTypes.object,
  client: PropTypes.object.isRequired,
}

export default ProjectOverviewPage
